import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

const WHATSAPP_NUMBER = '917249464781';
const BUSINESS_NAME = 'TSR Catering & Events';
const DEFAULT_MESSAGE = 'Hi, I would like to enquire about your services.';

function formatChatTime(date = new Date()) {
  return date.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

function buildWhatsAppUrl(text) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

function FloatingContact() {
  const [mounted, setMounted] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMounted(true);
  }, []);

  const bubbleTime = useMemo(() => formatChatTime(), [chatOpen]);

  const handleSend = (event) => {
    event.preventDefault();
    const text = message.trim() || DEFAULT_MESSAGE;
    window.open(buildWhatsAppUrl(text), '_blank', 'noopener,noreferrer');
    setMessage('');
    setChatOpen(false);
  };

  const toggleChat = () => {
    setChatOpen((open) => !open);
  };

  if (!mounted) return null;

  return createPortal(
    <div className={`tsr-wa-chat ${chatOpen ? 'tsr-wa-chat--open' : ''}`}>
      {chatOpen ? (
        <div className="tsr-wa-chat__panel" role="dialog" aria-label="WhatsApp chat">
          <header className="tsr-wa-chat__header">
            <div className="tsr-wa-chat__header-text">
              <div className="tsr-wa-chat__title">{BUSINESS_NAME}</div>
              <div className="tsr-wa-chat__subtitle">Replies within 1 day</div>
            </div>
            <button
              type="button"
              className="tsr-wa-chat__close"
              onClick={() => setChatOpen(false)}
              aria-label="Close chat"
            >
              &times;
            </button>
          </header>

          <div className="tsr-wa-chat__body">
            <div className="tsr-wa-chat__date">Today</div>
            <div className="tsr-wa-chat__bubble">
              <div className="tsr-wa-chat__bubble-author">{BUSINESS_NAME}</div>
              <p className="tsr-wa-chat__bubble-text">Hey! 👋 How can we help you?</p>
              <span className="tsr-wa-chat__bubble-time">{bubbleTime}</span>
            </div>
          </div>

          <form className="tsr-wa-chat__composer" onSubmit={handleSend}>
            <input
              type="text"
              className="tsr-wa-chat__input"
              placeholder="Enter your message"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              aria-label="Your message"
            />
            <button type="submit" className="tsr-wa-chat__send" aria-label="Send on WhatsApp">
              <i className="fas fa-paper-plane" aria-hidden="true" />
            </button>
          </form>
        </div>
      ) : null}

      <button
        type="button"
        className="tsr-wa-chat__fab"
        onClick={toggleChat}
        aria-expanded={chatOpen}
        aria-label={chatOpen ? 'Close WhatsApp chat' : 'Open WhatsApp chat'}
      >
        <i className="fab fa-whatsapp" aria-hidden="true" />
      </button>
    </div>,
    document.body
  );
}

export default FloatingContact;
